import { useEffect } from "react";
import { useMountEffect } from "primereact/hooks";
import { connect } from "react-redux";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import {
  listRequest,
  updateStatusRequest,
} from "../../../../store/slices/notificationSlice";
import CustomBreadCrumbs from "../../../common/breadcrumbs";
import List from "../../../common/list";
import { InputSwitch } from "primereact/inputswitch";
import * as RoleHelper from "../../../../helpers/RoleHelper";
import { AccessScopeConstants } from "../../../../constants";

const NotificationList = ({
  labels,
  list = [],
  action = "",
  requesting = false,
  listRequest,
  updateStatusRequest,
  user,
}) => {
  const intl = useIntl();
  const navigate = useNavigate();

  const { role } = user || {};
  const canUpdate = RoleHelper.checkRoleScope(
    role?.scope,
    AccessScopeConstants.EnterpriseAccess,
    AccessScopeConstants.UpdateScope
  );

  useMountEffect(() => {
    listRequest();
  });

  useEffect(() => {
    if (action === "update" && !requesting) {
      listRequest();
    }
  }, [action, requesting]);

  return (
    <div>
      <CustomBreadCrumbs labels={labels} navigate={navigate} />
      <div className="edexlms-page-content">
        <div className="edexlms-page-header">
          <div className="edexlms-page-title">
            {intl.formatMessage({ id: "notifications" })}
          </div>
        </div>
        <div className="edexlms-page-body notifications">
          <List
            data={list || []}
            selectionMode=""
            scrollHeight="calc(100vh - 64px - 20px - 42px - 50px)"
            pagination={false}
            columns={[
              {
                field: "name",
                header: "name",
              },
              {
                field: "status",
                header: "status",
                body: (rowData) => {
                  return (
                    <InputSwitch
                      tooltipOptions={{
                        showOnDisabled: true,
                        position: "bottom",
                      }}
                      tooltip={
                        canUpdate
                          ? ""
                          : intl.formatMessage({ id: "no_permission" })
                      }
                      disabled={!canUpdate}
                      checked={rowData.isEnabled}
                      onChange={(e) =>
                        (canUpdate &&
                          updateStatusRequest({
                            id: rowData.id,
                            status: e.value,
                          })) ||
                        null
                      }
                    />
                  );
                },
              },
            ]}
          />
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  listRequest: (params) => dispatch(listRequest(params)),
  updateStatusRequest: (params) => dispatch(updateStatusRequest(params)),
});

const mapStateToProps = (state) => ({
  list: state.notifications?.data,
  requesting: state.notifications.requesting,
  error: state.notifications.error,
  action: state.notifications.action,
  user: state.self?.user,
});

export default connect(mapStateToProps, mapDispatchToProps)(NotificationList);
